import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=47807604&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\VS Projects\\SieTest E\\SieTest 4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47807604')) {
      api.createRecord('47807604', component.options)
    } else {
      api.reload('47807604', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=47807604&", function () {
      api.rerender('47807604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/sietest/views/Home.vue"
export default component.exports